<template>
  <div
    class="flex absolute inset-0 overflow-y-auto"
    style="z-index: 500; max-width:100%; max-height:100%; overflow: hidden;"
  >
    <div
      class="warp-border inline-block mt-1"
      style="height:650px; width:650px;margin: auto; background:gray;"
    >
      <span
        :class="
          `absolute inline-block warp-header-border text-lg text-white bg-${color}`
        "
        style="height:30px; width:160px; margin-top:-32px; margin-left:-2px; text-align:center;"
        >台形補正編集</span
      >
      <!-- メニューボタン -->
      <div
        class="absolute warp-button-border"
        style="background:gray; margin-top:-2px; margin-left:648px;"
      >
        <button
          class="block warp-button text-white ml-1 mr-1 mt-1"
          style="height:30px; width:90px;"
          type="button"
          @click="save"
        >
          完了
        </button>
        <button
          class="block warp-button text-white ml-1 mr-1 mt-1 mb-1"
          style="height:30px; width:90px;"
          type="button"
          @click="close"
        >
          キャンセル
        </button>
      </div>
      <div id="save-target" class=" margin:auto;">
        <img
          class="warp-target"
          id="warp-img"
          :src="source"
          style="margin: auto; height: auto; max-height:646px; max-width:646px;"
        />
        <canvas id="warp-canvas"></canvas>
      </div>
      <div id="save-target2" class=" margin:auto;">
        <img class="warp-target2" id="warp-img2" :src="source" style="" />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, onUnmounted } from 'vue'
import { useImgUploader } from '@/services/useImgUploader'
import Moveable from 'moveable'
import domtoimage from 'dom-to-image'

export default {
  name: 'AppImageWarp',

  components: {},
  props: {
    source: String,
    index: Number,
    type: String,
    color: String,
  },
  setup(props) {
    let frame = ref()
    let moveable = ref()
    const image = ref('')

    let { closeImgWarp, putTrimImage } = useImgUploader()

    onUnmounted(() => {
      // ダイアログを閉じた後にMoveableの枠が残ってしまうためコンポーネントを削除
      moveable.value.destroy()
    })

    onMounted(() => {
      frame.value = {
        matrix: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
        // 回転ドラッグ用のパラメータ(一旦保留)
        translate: [0, 0],
        rotate: 0,
      }
      //moveableのオプションを設定しcanvasへ配置する。
      moveable.value = new Moveable(document.body, {
        target: document.querySelector('.warp-target'),
        warpable: true,
        draggable: true,
        rotatable: true,
        renderDirections: ['nw', 'n', 'ne', 'w', 'e', 'sw', 's', 'se'],
        throttleRotate: 0,
        rotationPosition: 'top',
        throttleDrag: 0,
        startDragRotate: 0,
        throttleDragRotate: 0,
        edge: false,
        zoom: 1,
        origin: true,
        padding: { left: 0, top: 0, right: 0, bottom: 0 },
      })

      moveable.value
        .on('warpStart', e => {
          e.set(frame.value.matrix)
        })
        .on('warp', e => {
          frame.value.matrix = e.matrix
          e.target.style.transform = e.transform
        })
        .on('dragStart', e => {
          e.set(frame.value.translate)
        })
        .on('drag', e => {
          frame.value.translate = e.beforeTranslate
          e.target.style.transform = e.transform
        })
        .on('rotateStart', e => {
          e.set(frame.value.rotate)
        })
        .on('rotate', e => {
          frame.value.rotate = e.beforeRotate
          e.target.style.transform = e.transform
        })
    })

    const save = async () => {
      // const warpImage = document.getElementById('warp-img')

      // warpImage.style.height = null
      // warpImage.style.width = null
      // warpImage.style.maxHeight = null
      // warpImage.style.maxWidth = null
      const saveImage = document.getElementById('save-target')
      await domtoimage.toPng(saveImage).then(function(dataUrl) {
        image.value = dataUrl
      })
      putTrimImage(image.value, props.index, props.type)
      closeImgWarp()
    }

    const close = () => {
      closeImgWarp()
    }
    return {
      frame,
      moveable,
      closeImgWarp,
      putTrimImage,
      close,
      save,
      image,
    }
  },
}
</script>
<style lang="scss" scoped>
.warp-border {
  border: solid 2px #fff;
}
.warp-header-border {
  border: solid 2px #fff;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
}
.warp-button-border {
  border: solid 2px #fff;
  border-left: none;
  border-radius: 0 8px 8px 0;
}
.warp-button {
  text-decoration: none;
  background: #549a1d50;
  // border: double 4px #fff;
  border: solid 2px #ffffff50;
  border-radius: 3px;
  transition: 0.4s;
}
.warp-end-button {
  text-decoration: none;
  background: #549a1d50;
  border: double 4px #ffffff50;
  border-radius: 3px;
  transition: 0.4s;
}
.warp-end-button:hover {
  background: #549a1d;
  border: double 4px #ffffff;
}
.warp-button:hover {
  background: #549a1d;
  border: solid 2px #ffffff;
}
html,
body {
  position: relative;
  height: 100%;
  margin: 0;
  padding: 0;
}
.description {
  padding: 10px;
}
</style>
